// modal.js
import { gsap } from "gsap";
import { trapFocus } from "../helpers/index.js";

// constants
const modal = document.querySelector(".modal");
const closeModalButton = document.querySelector(".modal-close");
const modalContent = document.querySelector(".modal-content");

// variables
let openModalButtons = document.getElementsByClassName("open-modal");
let modalTrigger;
let cleanupTrapFocus;

const modalTimeline = gsap.timeline({
  paused: true,
});
modalTimeline.to(modal, {
  ease: "Power4.easeInOut",
  duration: 0.2,
  autoAlpha: 1,
});

// open modal
function openModal(event) {
  event.preventDefault();

  // remove scroll from <html>
  document.documentElement.classList.add("no-scroll");

  // show modal
  modalTimeline.play().timeScale(1);

  // set trigger to focus on when closing the modal
  modalTrigger = event.currentTarget;

  // Update ARIA attributes
  modalTrigger.setAttribute("aria-expanded", "true");
  modal.setAttribute("aria-hidden", "false");
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-labelledby", "modal-title");

  // Set modal content
  const imageUrl = modalTrigger.getAttribute("data-image-url");
  if (imageUrl && modalContent) {
    modalContent.innerHTML = `
      <img src="${imageUrl}" alt="Vergrote foto" style="width: 100%; height: 100%; object-fit: contain;">
    `;
  }

  // trap focus in modal
  setTimeout(() => {
    cleanupTrapFocus = trapFocus(modal);
    closeModalButton.focus();
  }, 200); // time to show modal
}

// close modal
function closeModal() {
  modalTimeline.play().timeScale(-1);

  // add scroll from <html>
  document.documentElement.classList.remove("no-scroll");

  // hide modal
  modal.setAttribute("aria-hidden", "true");
  modal.removeAttribute("role");
  modal.removeAttribute("aria-modal");
  modal.removeAttribute("aria-labelledby");

  // Update trigger ARIA attributes
  if (modalTrigger) {
    modalTrigger.setAttribute("aria-expanded", "false");
  }

  // Clean up focus trap
  if (cleanupTrapFocus) {
    cleanupTrapFocus();
    cleanupTrapFocus = null;
  }

  // set focus to modal trigger (button)
  if (modalTrigger) {
    modalTrigger.focus();
  }
}

// open modal button event listeners
for (var i = 0; i < openModalButtons.length; i++) {
  openModalButtons[i].addEventListener("click", openModal, true);

  // Add keyboard support for Enter and Space
  openModalButtons[i].addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openModal(event);
    }
  });
}

// close modal button event listener
closeModalButton.onclick = function () {
  closeModal();
};

// Hide modal on keydown Escape
document.addEventListener("keyup", (e) => {
  if (e.code === "Escape" && modal && modal.getAttribute("aria-hidden") !== "true") {
    closeModal();
  }
});

// Close modal when clicking outside
modal.addEventListener("click", (e) => {
  if (e.target === modal) {
    closeModal();
  }
});
